/**
 * Starter copy for the two Staff doors into the same Ruta AI panel (RUT-3902).
 * Framing only — not two products. Classification / confirm-to-file is RUT-3903.
 */
export type RutaAiFraming = 'ask' | 'feedback';

export const ASK_ARIA_LABEL = 'Ask how to do something';

export const ASSISTANT_FRAMING = {
  ask: {
    greeting: 'What are you trying to do?',
    placeholder: 'How do I…?',
    chips: [
      'How do I request a service?',
      'How do I find a visit?',
      'How do I deactivate a service?',
      'Where do I add a credit to a customer?',
    ],
  },
  feedback: {
    greeting:
      "What’s wrong or missing? I’ll help first — we can send it to the product team if it’s a real gap.",
    placeholder: 'Something broke, or something’s missing…',
    chips: [] as string[],
  },
} as const;

export function framingCopy(framing: RutaAiFraming) {
  return ASSISTANT_FRAMING[framing];
}
